import React from 'react';

import {Button as AntButton} from 'antd';

import { NativeButtonProps } from 'antd/lib/button/button';
import styled from 'src/theme';

export const ForwardRefButton = React.forwardRef((props: any, ref: any) => (
  <StyledButton {...props}  ref={ref} />
));

export const StyledButton = styled((props) => <AntButton {...props} />)`
  & [ant-click-animating-without-extra-node]:after {
    border: 0 none !important;
    opacity: 0 !important;
    animation: 0 !important;
  }
  &:focus,
  &:hover,
  & {
    background-color: ${props => props.theme.colors.orange} !important;
    border-color: ${props => props.theme.colors.orange} !important;
    color: white !important;
    font-size: 13px !important;
    line-height: 1 !important;
    border-width: 0 !important;
    border-radius: 4px !important;
    height: 40px !important;
    padding: 12px 17px !important;
    box-shadow: 0 0 0 5px  fade(rgb(122, 122, 122),12%);
    --antd-wave-shadow-color: #0000ff;
  }
`;
export const Button = styled((props: NativeButtonProps, ref?: any ) => <AntButton {...props} ref={ref} />)`
  & [ant-click-animating-without-extra-node]:after {
    border: 0 none !important;
    opacity: 0 !important;
    animation: 0 !important;
  }
  &:focus,
  &:hover,
  & {
    background-color: ${props => props.theme.colors.orange} !important;
    border-color: ${props => props.theme.colors.orange} !important;
    color: white !important;
    font-size: 13px !important;
    line-height: 1 !important;
    border-width: 0 !important;
    border-radius: 4px !important;
    height: 40px !important;
    padding: 12px 17px !important;
    box-shadow: 0 0 0 5px  fade(rgb(122, 122, 122),12%);
    --antd-wave-shadow-color: #0000ff;
  }
`;
